/**
 * @generated SignedSource<<d1040c258fbf474e5446f9db7e496898>>
 * @relayHash 28437bd051bb517523bd8bb255843261
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 85b3986006d63f89d3e19402da0bff784515f638a958aa69ec615c07da730c60

import type { ConcreteRequest } from 'relay-runtime';
export type preloadEditButtonWithSpaceKeyQuery$variables = {
  spaceKey: string;
};
export type preloadEditButtonWithSpaceKeyQuery$data = {
  readonly space: {
    readonly id: string | null | undefined;
    readonly key: string | null | undefined;
  } | null | undefined;
  readonly spaceHomepage: {
    readonly id: string | null | undefined;
    readonly metadata: {
      readonly frontend: {
        readonly collabService: string | null | undefined;
        readonly embedded: boolean;
        readonly fabricEditorSupported: boolean | null | undefined;
      } | null | undefined;
    };
    readonly operations: ReadonlyArray<{
      readonly operation: string | null | undefined;
      readonly targetType: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly subType: string | null | undefined;
    readonly type: string | null | undefined;
  } | null | undefined;
};
export type preloadEditButtonWithSpaceKeyQuery = {
  response: preloadEditButtonWithSpaceKeyQuery$data;
  variables: preloadEditButtonWithSpaceKeyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "name": "key"
      }
    ]
  },
  {
    "args": [
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "spaceHomepage",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "name": "type"
      },
      {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "operation"
          },
          {
            "kind": "ScalarField",
            "name": "targetType"
          }
        ]
      },
      {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
            "kind": "LinkedField",
            "name": "frontend",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "fabricEditorSupported"
              },
              {
                "kind": "ScalarField",
                "name": "embedded"
              },
              {
                "kind": "ScalarField",
                "name": "collabService"
              }
            ]
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "subType"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "preloadEditButtonWithSpaceKeyQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "preloadEditButtonWithSpaceKeyQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "28437bd051bb517523bd8bb255843261",
    "id": "85b3986006d63f89d3e19402da0bff784515f638a958aa69ec615c07da730c60",
    "metadata": {},
    "name": "preloadEditButtonWithSpaceKeyQuery",
    "operationKind": "query",
    "text": "query preloadEditButtonWithSpaceKeyQuery($spaceKey:String!){space(key:$spaceKey){id,key},spaceHomepage(spaceKey:$spaceKey){id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType}}"
  }
};
})();

(node as any).hash = "d44363b7caa9c4f4861198079067c51c";

export default node;
